import { Row } from "@tanstack/react-table";

type WithFirst<T> = T & { isFirstOfAType?: true };

export function getNestedValue<T extends Record<string, any>>(
  obj: T,
  path: string
): unknown {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- key can not always be present
  return path.split(".").reduce((acc, key) => acc?.[key], obj);
}

// injects array with isFirstOfAType: true
export function markFirstOfType<T extends Record<string, any>>(
  arr: Row<T>[],
  groupBy?: string
): WithFirst<Row<T>>[] {
  if (!groupBy) return arr;

  const seen = new Set<unknown>();

  return arr.map((item) => {
    const value = getNestedValue(item.original, groupBy);
    if (!seen.has(value)) {
      seen.add(value);
      return { ...item, isFirstOfAType: true };
    }
    return item;
  });
}
